import "./download-tile.scss";
import React from "react";
import useTranslation from "locales";
import classNames from "classnames";

const DownloadTile = ({ title, link, extension, size, lang }) => {
  const { t } = useTranslation(lang);
  const fileIcon =
    extension && extension === "application/pdf"
      ? "file-pdf.svg"
      : extension === "application/zip"
      ? "file-zip.svg"
      : extension === "application/rar"
      ? "file-rar.svg"
      : extension === "image/jpg" || extension === "image/jpeg"
      ? "file-jpeg.svg"
      : "file-blank.svg";

  const fileSizeAmount =
    size > 1024 * 1024
      ? Math.ceil(size / (1024 * 1024))
      : size > 1024
      ? Math.ceil(size / 1024)
      : size;

  const fileSizeIndex =
    size > 1024 * 1024
      ? "MB"
      : size > 1024
      ? "KB"
      : (size = 0 || null || undefined ? "" : "B");

  const fileSize = `(${fileSizeAmount} ${fileSizeIndex})`;
  return (
    <a
      href={link}
      download
      target="_blank"
      rel="noreferrer nofollow"
      style={{ display: "block" }}
    >
      <div className={classNames("download-tile", {
        ['download-tile--missing-file']: !link,
      })}>
        <img
          src={require(`assets/images/${fileIcon}`).default}
          alt=""
          className="download-tile__icon"
        />
        <div className="download-tile__text-wrapper">
          <div className="download-tile__title">{title}</div>
          <div className="download-tile__btn">
            {link ? t("Pobierz") : t("Brak pliku")}{" "}
            <img
              src={require("assets/icons/download-arrow.svg").default}
              alt=""
              className="download-tile__btn-icon"
            />
          </div>
        </div>
      </div>
    </a>
  );
};

export default DownloadTile;
